import * as angular from 'angular';
import * as _ from 'lodash';

import { IActionService } from '../../services';
import { IAction as Action } from '../../models';
import { Store } from '../Store';
import * as ACTIONS from './actions.constants';

import {
    loadActions,
    loadActionsSuccess,
    deleteAction,
    deleteActionSuccess,
    updateAction,
    updateActionSuccess,
    addActionSuccess,
    addAction
} from './actions.actions';


export interface IActionActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<Action[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<Action[]>;
    addOne(target: Action): (dispatch: any, getState: () => Store) => angular.IPromise<Action[]>;
    updateOne(target: Action): (dispatch: any, getState: () => Store) => angular.IPromise<Action[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<Action[]>;
}

export class ActionsActionsService implements IActionActionsService {
    static serviceId = 'actionActionsService';

    static $inject = ['$q', 'actionService'];

    constructor(
        private _$q: angular.IQService,
        private _actionService: IActionService
    ) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { actions } = getState();
            if (force || (!actions.isLoading && !actions.isLoaded)) {
                dispatch(loadActions());
                return this._actionService.getAll(force)
                    .then(data => {
                        dispatch(loadActionsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: ACTIONS.ACTIONS_LOAD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(_.values<Action>(actions.dictionary));
            }
        };
    }

    addOne(action: Action) {
        return (dispatch: any, getState: () => Store) => {
            if (action) {
                dispatch(addAction(action));
                return this._actionService.addOne(action)
                    .then(data => {
                        dispatch(addActionSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: ACTIONS.ACTION_ADD_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    updateOne(action: Action) {
        return (dispatch: any, getState: () => Store) => {
            if (action) {
                dispatch(updateAction(action));
                return this._actionService.updateOne(action)
                    .then(data => {
                        dispatch(updateActionSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: ACTIONS.ACTION_UPDATE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            if (guid) {
                dispatch(deleteAction(guid));
                return this._actionService.deleteOne(guid)
                    .then(data => {
                        dispatch(deleteActionSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: ACTIONS.ACTION_DELETE_ERROR, payload: reason });
                        throw reason;
                    });
            } else {
                return this._$q.when(null);
            }
        };
    }
}